<template>
  <article class="block tablet:flex items-center-safe gap-12 spacer-block text-brand-dark bg-brand-light block-round">
    <div
      class="basis-2/5 mb-4 tablet:mb-0 text-center"
      :class="{
        'tablet:text-start': odd,
        'tablet:text-end': !odd,
      }"
    >
      <header class="mb-3">
        <h3 class="article-title mb-3 block">
          {{ title }}
        </h3>
        <dl
            class="grid grid-cols-2 gap-x-2 opacity-66 text-sm w-25 max-tablet:mx-auto"
            :class="{
              'tablet:place-items-start': odd,
              'tablet:place-items-end tablet:ml-auto': !odd,
            }"
        >
          <template v-if="duration">
            <dt class="text-end">
              {{ t('service.duration') }}
            </dt>
            <dd class="text-start">
              {{ duration }}
            </dd>
          </template>

          <template v-if="price">
            <dt class="text-end">
              {{ t('service.price') }}
            </dt>
            <dd class="text-start">
              {{ price }}
            </dd>
          </template>
        </dl>
      </header>
      <div>
        <p v-if="summary">{{ summary }}</p>
        <slot name="summary"/>
      </div>
    </div>
    <picture
            class="basis-1/2 w-full relative block aspect-[2] rounded-2xl overflow-hidden"
    >
      <media-source
              :uri="imgUri"
              :expose-only="false"
              :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
              sizes="100vw"
              :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
              format="webp"
              as="source"
      />
      <media-source
              :uri="imgUri"
              :expose-only="false"
              :dimensions="[
                        { width: 2560 },
                        { width: 1920 },
                        { width: 1400 },
                        { width: 720 },
                    ]"
              sizes="100vw"
              format="jpg"
              as="img"
              class="w-full h-full object-cover relative z-1"
      />
      <a
        v-if="bookingUrl"
        :href="bookingUrl"
        class="text-light text-sm tablet:text-base absolute right-2 tablet:right-4 bottom-2 tablet:bottom-4 z-5 bg-brand-dark/66 rounded-full px-4 py-1 tablet:px-6 tablet:py-2 hover:bg-brand transition-colors"
      >
        {{ t('service.book_now') }} <ArrowRightIcon class="size-4 ms-1 inline-block"/>
      </a>
    </picture>
  </article>
</template>

<script lang="ts" setup>
import { ArrowRightIcon} from "@heroicons/vue/20/solid";

const {
    title,
    summary = '',
    price,
    duration,
    imgUri,
    odd,
    bookingUrl = '',
} = defineProps<{
    title: string,
    summary?: string,
    duration: string,
    price: string,
    imgUri: string,
    bookingUrl?: string,
    odd: boolean;
}>();

const { t } = useI18n();

const config = useRuntimeConfig().public;
</script>